var scope_0 = require('/home/runner/work/MinervaTools.net/MinervaTools.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2458681fd8b3ac6ffa985e8791e803ed.js').default;
var scope_1 = require('/home/runner/work/MinervaTools.net/MinervaTools.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9555052e848ceb1833d139279aea246.js').default;
var scope_2 = require('/home/runner/work/MinervaTools.net/MinervaTools.net/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    